var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgPlayButton = function SvgPlayButton(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    fill: "none",
    viewBox: "0 0 50 50"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M25 50c13.807 0 25-11.193 25-25S38.807 0 25 0 0 11.193 0 25s11.193 25 25 25m-5.378-34.298c-.21.276-.21.777-.21 1.778v14.452c0 1.001 0 1.502.21 1.777.182.24.462.39.764.408.347.02.765-.257 1.602-.813l10.893-7.226c.691-.459 1.037-.688 1.158-.977a1.03 1.03 0 0 0 0-.79c-.12-.29-.467-.518-1.158-.977l-10.893-7.226c-.837-.556-1.255-.833-1.602-.813a1.04 1.04 0 0 0-.764.407",
    clipRule: "evenodd"
  })));
};
export default SvgPlayButton;